import { DocumentArrowDownIcon, LinkIcon } from '@heroicons/react/24/outline';

import { CustomerExportOptionParams } from '@/sections/customerManagement/types';
import type { DropdownOption } from '@/types/dropdown.types';

/**
 * Builds export/share action dropdown options
 *
 * Provides options for exporting customer data and sharing customer URLs.
 *
 * @param params - Parameters for building export options
 * @returns Array of dropdown options for export and share actions
 */
export const getCustomerExportOptions = ({
  customers,
  handlers,
}: CustomerExportOptionParams): DropdownOption[] => {
  const hasCustomers = customers.length > 0;

  return [
    {
      label: 'Export as CSV',
      icon: <DocumentArrowDownIcon className="size-5" />,
      onClick: () => handlers.handleExport(customers, 'csv'),
      disabled: !hasCustomers,
    },
    {
      label: 'Export as JSON',
      icon: <DocumentArrowDownIcon className="size-5" />,
      onClick: () => handlers.handleExport(customers, 'json'),
      disabled: !hasCustomers,
    },
    {
      label: '',
      isDivider: true,
    },
    {
      label: 'Share URLs',
      icon: <LinkIcon className="size-5" />,
      onClick: () => handlers.handleShare(customers),
      disabled: !hasCustomers,
      count: ` ⌥ S`,
    },
  ];
};
